export const iconFontAwesomeTransportationTruckMonster = (
	<i className="fa-solid fa-truck-monster"></i>
);
